import links from "@/links/links";

export default {
  actions: {
    GET(id) {
      return this.get(links.USER_GET(id));
    },
    GET_ADMIN_BY_AGENCY(agencyId) {
      return this.get(links.USER_GET_ADMIN_BY_AGENCY(agencyId));
    },
    PUT(item) {
      return this.put(links.USER_PUT(item.id), item);
    },
  },
};
